export type BiometricsProps = {
    onSubmit: (isFailedVerification?: boolean) => Promise<boolean>;
    isLoading: boolean;
};

export enum SelfieStepEnum {
    INFO = 'info',
    LIVENESS = 'liveness',
    SUCCESS = 'success',
}
